<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g
      id="Group_5361"
      data-name="Group 5361"
      transform="translate(-1196.921 -850.812)"
    >
      <rect
        id="Rectangle_1898"
        data-name="Rectangle 1898"
        width="24"
        height="24"
        transform="translate(1196.921 850.812)"
        fill="none"
      />
      <g
        id="Rectangle_1870"
        data-name="Rectangle 1870"
        transform="translate(1196.921 852.811)"
        fill="#fff"
        stroke="#2d323c"
        stroke-width="2"
      >
        <rect width="24" height="22" rx="4" stroke="none" />
        <rect x="1" y="1" width="22" height="20" rx="3" fill="none" />
      </g>
      <g
        id="Rectangle_1871"
        data-name="Rectangle 1871"
        transform="translate(1196.921 852.811)"
        fill="#ff66a2"
        stroke="#2d323c"
        stroke-width="2"
      >
        <path
          d="M4,0H20a4,4,0,0,1,4,4V9a0,0,0,0,1,0,0H0A0,0,0,0,1,0,9V4A4,4,0,0,1,4,0Z"
          stroke="none"
        />
        <path
          d="M4,1H20a3,3,0,0,1,3,3V7a1,1,0,0,1-1,1H2A1,1,0,0,1,1,7V4A3,3,0,0,1,4,1Z"
          fill="none"
        />
      </g>
      <path
        id="Path_2534"
        data-name="Path 2534"
        d="M3144.542,432.438v5"
        transform="translate(-1940.665 419.374)"
        fill="none"
        stroke="#2d323c"
        stroke-linecap="round"
        stroke-width="2"
      />
      <path
        id="Path_2535"
        data-name="Path 2535"
        d="M3144.542,432.438v5"
        transform="translate(-1930.229 419.374)"
        fill="none"
        stroke="#2d323c"
        stroke-linecap="round"
        stroke-width="2"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'CalendarColored',
}
</script>

<style lang="scss" scoped></style>
